import Axios from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { TerritoryManagementAxios } from "../Contracts/Axios/TerritoryManagementAxios";
import { ITerritoryType, ITerritoryTypePermission } from "../Models/Models";
import * as types from "./Types";

// GET
export const getTerritoryTypePermissions: ActionCreator<
  ThunkAction<any, any, any, any>
> = (territoryTypeID: number) => {
    return (dispatch: Dispatch): void => {
        const tma = new TerritoryManagementAxios();
        const promises = [];
        promises.push(tma.GetTerritoryTypePermissions(territoryTypeID));

        Axios.all(promises)
            .then(
                Axios.spread((data) => {
                    dispatch(getTerritoryTypePermissionsSuccess(data));
                })
            )
            .catch((error: any) => {
                dispatch(getTerritoryTypePermissionsFailure(error));
            });
    };
};

// UPDATE
export const updateTerritoryTypeAdminOnlyProperty: ActionCreator<
  ThunkAction<any, any, any, any>
> = (territoryType: ITerritoryType) => {
    return (dispatch: Dispatch): void => {
        const tma = new TerritoryManagementAxios();
        const promises = [];
        promises.push(tma.UpdateTerritoryTypeAdminOnlyProperty(territoryType));

        Axios.all(promises)
            .then(
                Axios.spread((data) => {
                    dispatch(updateTerritoryTypeAdminOnlyPropertySuccess(data));
                })
            )
            .catch((error: any) => {
                dispatch(updateTerritoryTypeAdminOnlyPropertyFailure(error));
            });
    };
};

// UPDATE
export const updateTerritoryTypeUserPermissions: ActionCreator<
  ThunkAction<any, any, any, any>
> = (
    userID: number,
    territoryTypeID: number,
    canView: boolean,
    canEdit: boolean
) => {
    return (dispatch: Dispatch): void => {
        const tma = new TerritoryManagementAxios();
        const promises = [];
        promises.push(
            tma.UpdateTerritoryTypeUserPermissions(
                userID,
                territoryTypeID,
                canView,
                canEdit
            )
        );

        Axios.all(promises)
            .then(
                Axios.spread((data) => {
                    dispatch(updateTerritoryTypeUserPermissionsSuccess(data));
                })
            )
            .catch((error: any) => {
                dispatch(updateTerritoryTypeUserPermissionsFailure(error));
            });
    };
};

// UPDATE
export const updateTerritoryTypeUserPermissionsForAll: ActionCreator<
  ThunkAction<any, any, any, any>
> = (territoryPermissions: Array<ITerritoryTypePermission>) => {
    return (dispatch: Dispatch): void => {
        const tma = new TerritoryManagementAxios();
        const promises = [];
        promises.push(
            tma.UpdateTerritoryTypeUserPermissionsForAll(territoryPermissions)
        );

        Axios.all(promises)
            .then(
                Axios.spread((data) => {
                    dispatch(updateTerritoryTypeUserPermissionsForAllSuccess(data));
                })
            )
            .catch((error: any) => {
                dispatch(updateTerritoryTypeUserPermissionsForAllFailure(error));
            });
    };
};

//------------------------------------------------ SUCCESS
const updateTerritoryTypeAdminOnlyPropertySuccess = (data: null) => ({
    type: types.UPDATE_TERRITORY_TYPE_ADMIN_ONLY_SUCCESS,
    response: data,
});
const updateTerritoryTypeUserPermissionsSuccess = (data: null) => ({
    type: types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_SUCCESS,
    response: data,
});
const getTerritoryTypePermissionsSuccess = (
    data: Array<ITerritoryTypePermission>
) => ({
    type: types.GET_TERRITORY_TYPE_PERMISSIONS_SUCCESS,
    response: data,
});
const updateTerritoryTypeUserPermissionsForAllSuccess = (
    data: Array<ITerritoryTypePermission>
) => ({
    type: types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FOR_ALL_SUCCESS,
    response: data,
});
//------------------------------------------------ FAILURE
const updateTerritoryTypeAdminOnlyPropertyFailure = (error: any) => ({
    type: types.UPDATE_TERRITORY_TYPE_ADMIN_ONLY_FAILURE,
    response: error,
});
const updateTerritoryTypeUserPermissionsFailure = (data: null) => ({
    type: types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FAILURE,
    response: data,
});
const getTerritoryTypePermissionsFailure = (data: null) => ({
    type: types.GET_TERRITORY_TYPE_PERMISSIONS_FAILURE,
    response: data,
});
const updateTerritoryTypeUserPermissionsForAllFailure = (data: null) => ({
    type: types.UPDATE_TERRITORY_TYPE_USER_PERMISSIONS_FOR_ALL_FAILURE,
    response: data,
});
